import type { StateCreator } from 'zustand';
import { getDefaultPlanningYear } from '../../config/business';

/** Глобальный год планирования — единый источник истины для всех таблиц. */
export interface PlanningYearSlice {
  planningYear: number;
  setPlanningYear: (year: number) => void;
}

export const createPlanningYearSlice: StateCreator<
  PlanningYearSlice,
  [],
  [],
  PlanningYearSlice
> = (set) => ({
  planningYear: getDefaultPlanningYear(),
  setPlanningYear: (year) => set({ planningYear: year }),
});
